import React from 'react';
import { Link } from 'react-router-dom';
import Footer from './Footer';

function NotFound() {
  return (
    <main id="main-content">
      <div style={{ textAlign: 'center', padding: '200px 20px 100px', minHeight: '60vh' }}>
        <h1 style={{ fontSize: '4rem', marginBottom: '16px' }}>404</h1>
        <p style={{ color: 'rgba(255,255,255,0.6)', fontSize: '1.2rem', marginBottom: '30px' }}>
          Page not found.
        </p>
        <Link
          to="/"
          className="cta-button"
          style={{ display: 'inline-block', padding: '12px 30px', textDecoration: 'none' }}
        >
          Go Home
        </Link>
      </div>
      <Footer />
    </main>
  );
}

export default NotFound;
